/**
 * Builds the accessible name for a PDP color-variant control, e.g.
 * "Color: graugrün" (ECOM-2461). The prefix is the already-translated
 * `pdp.color` label, so the announced name matches the visible color heading
 * and stays localized with no hardcoded language.
 *
 * Returns `undefined` when no color label is available, so the caller emits no
 * `aria-label` at all rather than a dangling "Color: " with an empty value.
 */
export const getColorPickerAriaLabel = (
  colorLabel?: string,
  colorPrefix?: string,
): string | undefined => {
  if (!colorLabel) {
    return undefined
  }

  return colorPrefix ? `${colorPrefix}: ${colorLabel}` : colorLabel
}
